module.exports = __webpack_public_path__ + "img/Elements site web avec logo.a22a10db.png";